import Layout from '@/layout/index.vue';
import { RouteRecordRaw } from 'vue-router';
import My from '@/views/my/index.vue';
import Admin from '@/views/admin/index.vue';

import myRoutes from './myRoutes';
import adminRoutes from './adminRoutes';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/redirect',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/Redirect.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/Logout.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/lostPassword',
    name: 'lostPassword',
    component: () => import('../views/LostPassword.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/connect',
    name: 'connect',
    component: () => import('../views/connect/index.vue'),
    meta: { anonymous: true },
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/Error.vue'),
    meta: { title: '错误日志' },
  },
  {
    path: '/',
    name: 'Home',
    component: Layout,
    redirect: '/my/hosts/',
    children: [
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '修改资料' },
      },
      {
        path: 'password',
        name: 'password',
        component: () => import('@/views/Password.vue'),
        meta: { title: '修改密码' },
      },
      {
        path: '/my',
        name: 'My',
        component: My,
        children: myRoutes,
      },
      {
        path: '/admin',
        name: 'Admin',
        component: Admin,
        children: adminRoutes,
      },
    ],
  },
];

export default routes;
